import { Box } from '@mui/material';
import React, { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { useAppDispatch } from '../../app/hooks';
import { FeatureEnum } from '../../services/data/impl/cube/cubeSlice';
import { setMaskColor } from './imageSlice';

interface Props {
  maskColor: string;
  feature: FeatureEnum;
}

const MaskColorPicker: React.FC<Props> = ({ maskColor, feature }) => {
  const dispatch = useAppDispatch();
  const [isOpen, toggle] = useState(false);

  return (
    <Box sx={{ position: 'relative' }}>
      <Box
        sx={{
          width: 24,
          height: 24,
          borderRadius: '4px',
          border: '2px solid #fff',
          boxShadow:
            '0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1)',
          cursor: 'pointer',
        }}
        style={{ backgroundColor: maskColor }}
        onClick={(e) => {
          e.stopPropagation();
          toggle(!isOpen);
        }}
      />

      {isOpen && (
        <Box
          sx={{
            position: 'absolute',
            top: 'calc(100% + 2px)',
            right: 0,
            borderRadius: 9,
            boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
            zIndex: 1000,
          }}
        >
          <HexColorPicker
            color={maskColor}
            onChange={(color) =>
              dispatch(setMaskColor({ layer: feature, newValue: color }))
            }
          />
        </Box>
      )}
    </Box>
  );
};

export default MaskColorPicker;
